const isDevelopment = import.meta.env.MODE === 'development'

export const SERVER_URL = isDevelopment
  ? 'http://localhost:8080'
  : 'https://treasury-api-uat.maranathaofcanada.org'

export const API_PATH = `${SERVER_URL}/api`

// CRUD operations
export const CREATE = 'create'
export const EDIT = 'edit'
export const DELETE = 'delete'

// Error messages
export const AUTH_ERROR_MESSAGE = 'Authentication required'
